import React from 'react';
import Navigation from '../components/Navigation';
import { AwningQuoteForm } from '../components/AwningQuoteForm';
import Footer from '../components/Footer';

export const AwningQuotePage: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Navigation />
      <AwningQuoteForm />
      <Footer />
    </div>
  );
};
